import { useEffect } from "react";
import Message from "../components/Message";

export default function IntegrationSuccess() {
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const integrationId = params.get("integrationId");
        console.log(integrationId);
    }, []);

    return (
        <div className="p-4">
            <Message success>
                Integration successfully connected! You can now close this
                window.
            </Message>
        </div>
    );
}
